module.exports = "/_next/static/images/row1-1-70af3b44f18e2706770a9e5802033da9.png";